import { render } from "./AppFooter.vue?vue&type=template&id=106d3105"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=106d3105&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__